import React from 'react';

export const PageCover = (props) => {

	return(
		<figure className='profileHeader'>
			<div className='darkOverlay' />
			<h1>Label:<br/>{props.name}</h1>
			<img className='profileCoverImage' src={props.cover} alt={props.alt}/>
			<ul>
				<li>Date Establised /<br />{props.year}</li>
				<li>Location /<br />{props.origin}</li>
				<li>Email /<br />{props.email}</li>
				<li>On the Internet /<br /><a href={props.facebook}>Facebook</a> / <a href={props.website}>Website</a> / <a href={props.soundcloud}>Soundcloud</a> /</li>
			</ul>
		</figure>
	);
}